import { render, staticRenderFns } from "./ManageDomainView.vue?vue&type=template&id=80835a3c&"
import script from "./ManageDomainView.vue?vue&type=script&lang=js&"
export * from "./ManageDomainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports